import React, { useState, useEffect, useImperativeHandle, forwardRef, useRef } from 'react';

import { SingleInput } from '../../Res/BaseInput';
import { ReqSalaryItem } from '../../../../item/ItemContractorAttendance_RecruitmentItem_SalaryBase';
import { ReqAttendanceHourItem } from '../../../../item/ItemContractorAttendance_RecruitmentItem_SalaryHourly';

export const ContractorAttendanceDailogAttendanceHour = forwardRef((props, ref) => {
    const [AttendanceHourItems, setAttendanceHourItems] = useState([])

    useEffect(() => {
        if (props.obj !== undefined && props.obj !== AttendanceHourItems) {
            setAttendanceHourItems(props.obj)
        }
    }, [props.obj])

    // useEffect(() => {
    //     // console.log(props)
    //     console.log(SalaryAddAmount)
    // })

    function setAttendanceHourItem(attendanceHourItem) {
        var change = false
        AttendanceHourItems.forEach((item, index, arr) => {
            if (item.key === attendanceHourItem.key) {
                arr[index] = attendanceHourItem
                change = true
            }
        });
        if (change) {
            // console.log(AttendanceHourItems)
            setAttendanceHourItems(JSON.parse(JSON.stringify(AttendanceHourItems)))
        }
    }

    // useEffect(()=>{
    //     console.log(AttendanceHourItems)
    // },[AttendanceHourItems])

    useImperativeHandle(ref, () => ({
        send: () => {
            props.action({ AttendanceHourItems })
        }
    }));
    return (
        <table className="table table-striped table-bordered table-hover  dataTable">
            <thead>
                <tr role="row">
                    <th className="text-center sorting col-sm-4">項目名稱</th>
                    <th className="text-right sorting col-sm-4">小時</th>
                </tr>
                {
                    AttendanceHourItems.map((item) => (
                        <DailogAttendanceHourItem key={item.key} attendanceHourItem={item} action={setAttendanceHourItem} />
                    ))
                }
            </thead>
        </table>
    )
})

function DailogAttendanceHourItem({ attendanceHourItem, action }) {
    const [AttendanceHourItem, setAttendanceHourItem] = useState(new ReqAttendanceHourItem({}))
    const [name, setName] = useState("")
    const [hours, setHours] = useState(0)

    const [init, setInit] = useState(true)

    useEffect(() => {
        // console.log(attendanceHourItem)
        if (attendanceHourItem !== undefined && Object.keys(attendanceHourItem).length !== 0 && attendanceHourItem !== AttendanceHourItem) {
            setName(attendanceHourItem.name)
            setHours(attendanceHourItem.hours)
            setAttendanceHourItem(attendanceHourItem)
            // console.log(item)
        }
    }, [attendanceHourItem])

    function inputHour(hour) {
        // console.log(amount)
        var item = new ReqAttendanceHourItem({})
        item.fromJson(AttendanceHourItem)
        item.setHours(hour)
        action(item)
    }

    return (

        <tr role="row">
            <td className="text-center">{name}</td>
            <td className="text-right">
                <SingleInput val={hours} action={inputHour} placeholder={176} size={12} type={"number"} isRight={true} />
            </td>
        </tr>
    )
}